<template>
  <div :style="boxWrapStyleObj" class="nj-header-title" style="position: relative;">
    <!--  -->
    <div>
      <div class="header-title-area" ref="statisTitle">
        <div class="area-title">
          <img src="../../../assets/images/nanjindataboard/right-row.png" />
          <p class="title-text">学科应用分析</p>
        </div>
        <img src="../../../assets/images/nanjindataboard/bottom-bg.png" style="float: left" />
      </div>
      <Spin size="large" v-show="isShowSpin" class="spin-load"></Spin>
      <div class="content" :style="contentStyleObj" v-show="!isShowSpin">
        <div class="district-subject-wrap">
          <div class="left-container" style="width: 57%">
            <div class="left-container-wrap">
              <div class="subject-count-title" :style="rowStyleObj">
                <span class="subject-title" style="width: 30%">学科</span>
                <span class="count-title" style="width: 70%">使用次数</span>
              </div>
              <template v-for="(item, index) in subjectMap" v-if="subjectMap.length > 0 && index < 5">
                <div class="subject-count-name" v-if="index % 2 === 0" :style="rowStyleObj"
                  style="background-color: #102243">
                  <span class="subject-name" style="width: 30%">{{
                    item.subjectName
                  }}</span>
                  <span class="submit-count" style="width: 70%" :title="item.useNum + '次'">{{ item.useNum }}次</span>
                </div>
                <div class="subject-count-name" v-else :style="rowStyleObj">
                  <span class="subject-name" style="width: 30%">{{
                    item.subjectName
                  }}</span>
                  <span class="submit-count" style="width: 70%" :title="item.useNum + '次'">{{ item.useNum }}次</span>
                </div>
              </template>
            </div>
            <!--</div>-->
          </div>
          <div class="left-container" style="width: 43%">
            <!--图例-->
            <div class="echart-legend">
              <template v-for="(item) in phaseList">

                <div class="legend-item" @click="selectLegend(1)" v-if="item == 1">
                  <p class="legend-item-color" :style="legendIndex == '1'
                      ? { background: '#24C4DC' }
                      : { background: '#A2A2A2' }
                    "></p>
                  <p class="legend-item-text">小学</p>
                </div>
                <div class="legend-item" @click="selectLegend(2)" v-if="item == 2">
                  <p class="legend-item-color" :style="legendIndex == '2'
                      ? { background: '#ED8167' }
                      : { background: '#A2A2A2' }
                    "></p>
                  <p class="legend-item-text">初中</p>
                </div>
                <div class="legend-item" @click="selectLegend(3)" v-if="item == 3">
                  <p class="legend-item-color" :style="legendIndex == '3'
                      ? { background: '#FAE17C' }
                      : { background: '#A2A2A2' }
                    "></p>
                  <p class="legend-item-text">高中</p>
                </div>
              </template>
            </div>
            <div style="width: 100%; height: 100%" id="data_homework"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSubjectApplyAnalysisAPI, getPhaseListAPI } from "@/service/api"
export default {
  name: "subject-applica-analy",
  props: {
    screenHeight: Number,
    titleHeight: Number,
    areaParams: Object,
    regionId: String,
    isTowns: String
  },
  data() {
    return {
      legendIndex: "初中",
      color: [
        { offset: 0, color: "#00FEFF" },
        { offset: 0.9, color: "#24C4DC" },
        { offset: 1, color: "#24C4DC" },
      ],
      data: [
        {
          subject_name: "数学",
          count: "1036154",
        },
        {
          subject_name: "语文",
          count: "924756",
        },
        {
          subject_name: "英语",
          count: "669914",
        },
        {
          subject_name: "物理",
          count: "306726",
        },
        {
          subject_name: "生物",
          count: "239582",
        },
        {
          subject_name: "历史",
          count: "225848",
        },
      ],
      screenWidth: 0, //屏幕宽度
      boxWrapStyleObj: {
        height: "",
      },
      contentStyleObj: {
        height: "",
      },
      rowStyleObj: {
        height: "",
        lineHeight: "",
      },
      subjectMap: [],
      phaseList: [],
      isShowSpin: true
    };
  },
  watch: {
    screenHeight: "initBoxHeight",
    titleHeight: "initBoxHeight",
  },
  methods: {
    /**
     * @name 获取学段
     */
    async getSubjectApplyPhase() {
      let _this = this;
      let params = {
        province: this.areaParams.provinceCode,
        city: this.areaParams.cityCode,
        districtId: this.areaParams.districtCode,
        regionId: this.regionId,
      }
      let res = await getPhaseListAPI(params);
      _this.phaseList = res;
      if (_this.phaseList.length > 0) {
        _this.selectLegend(_this.phaseList[0]);
      }
    },
    /**
     * @name 获取应用学科
     */
    async selectLegend(phase) {
      let _this = this;
      let seriesDataArr = [];
      let indicator = [];
      this.legendIndex = phase;
      let color = '';
      let name = '';
      let colorList = [];
      this.isShowSpin = true;
      let params = {
        province: this.areaParams.provinceCode,
        city: this.areaParams.cityCode,
        districtId: this.areaParams.districtCode,
        regionId: this.regionId,
        phase: phase
      }
      let res = await getSubjectApplyAnalysisAPI(params);
      _this.subjectMap = res;
      _this.isShowSpin = false;
      //按降序排序
      _this.subjectMap.sort(function (a, b) {
        return b.useNum > a.useNum ? 1 : -1;
      });
      switch (phase) {
        case 1:
          name = '小学';
          color = "#2783CD";
          colorList = [
            { offset: 0, color: "#00FEFF" },
            { offset: 0.9, color: "#24C4DC" },
            { offset: 1, color: "#24C4DC" },
          ]
          break;
        case 2:
          name = '初中';
          color = "#FFB888";
          colorList = [
            { offset: 0, color: "#ED8167" },
            { offset: 0.9, color: "#ED8167" },
            { offset: 1, color: "#ED8167" },
          ]
          break;
        case 3:
          name = '高中';
          color = "#FAFA6B";
          colorList = [
            { offset: 0, color: "#FAE17C" },
            { offset: 0.9, color: "#FAE17C" },
            { offset: 1, color: "#FAE17C" },
          ]
          break;
      }
      seriesDataArr = [
        {
          value: _this.subjectMap.map((item) => item.useNum),
          name: name,
          areaStyle: {
            normal: {
              opacity: 0.78,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, colorList),
            },
          },
        },
      ];
      let maxUseNum = Math.max(...seriesDataArr[0].value);
      indicator = _this.subjectMap.map((item) => {
        return {
          name: item.subjectName,
          max: maxUseNum,
        }
      });
      _this.color = colorList;
      _this.$nextTick(() => {

        _this.initHomework(seriesDataArr, indicator, color);

      })
    },

    /**
     * 初始化box高度
     */
    initBoxHeight() {
      let winHeight = window.innerHeight;
      if (winHeight < 900) {
        winHeight = 938;
      }
      let boxWrapHeight = (winHeight - 128 - 10 - 30 - 20) / 3;
      let contentHeight =
        boxWrapHeight - this.$refs.statisTitle.offsetHeight - 20;
      this.boxWrapStyleObj.height = boxWrapHeight + "px";
      this.contentStyleObj.height = contentHeight + "px";
      let rowHight = contentHeight / 7;
      this.rowStyleObj.height = rowHight + "px";
      this.rowStyleObj.lineHeight = rowHight + "px";
    },
    /**
     * 加载饼状图
     */
    initHomework(data, indicator, color) {
      let dataSourcePie = this.$echarts.init(
        document.getElementById("data_homework")
      );
      let radiusVal = 60;
      let fontSize = 12;
      if (this.screenWidth <= 1280) {
        radiusVal = 30;
      }
      const option = {
        tooltip: {},
        radar: {
          name: {
            textStyle: {
              formatter: "{value}",
              color: "#708ACC",
              fontSize: fontSize,
            },
          },
          center: ["55%", "50%"],
          radius: radiusVal,
          shape: "circle",
          splitArea: {
            areaStyle: {
              color: color,
              opacity: 0.2,
              shadowColor: "#D2F7F9",
              shadowBlur: 10,
            },
          },
          splitLine: {
            lineStyle: {
              width: 1,
              color: color,
              opacity: 0.45,
            },
          },
          axisLine: {
            lineStyle: {
              color: "#708ACC",
            },
          },
          indicator: indicator,
        },
        series: [
          {
            name: "",
            type: "radar",
            symbol: "none", //去掉边拐点
            itemStyle: {
              normal: {
                lineStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, this.color),
                },
              },
            },
            data: data,
          },
        ],
      };
      dataSourcePie.setOption(option);

      window.addEventListener("resize", function () {
        dataSourcePie.resize();
      });
    },

  },
  mounted() {
    //获取屏幕宽度
    this.screenWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    this.initBoxHeight();

    this.$nextTick(() => {
      this.getSubjectApplyPhase();
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";

.header-title-area {
  margin-bottom: 30px;

  .area-title {
    display: flex;
    align-items: center;

    img {
      width: 13px;
      height: 20px;
      margin-right: 5px;
    }

    .title-text {
      font-size: 18px;
      font-weight: bold;
      color: #00bbff;
    }
  }
}

.spin-load {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
}
</style>
